import { LitElement, html, css } from 'lit'
import 'bui/elements/table'
import 'bui/elements/table-row'
import './usgs-chart'

customElements.define('m-feature-detail-usgs', class extends LitElement{

    static styles = css`
        :host {
            display: block;
            position:relative;
            padding: 1em;
        }

        m-feature-detail-usgs-chart {
            padding-top: 0;
            padding-left: 0;
            padding-right: 0;
        }

        b-table-row { order: 100; }
        b-table-row[sensor="Streamflow"] { order: 1; }
        b-table-row[sensor="Gage Height"] { order: 1; }
    `

    onModelChange(model){
        if( model )
            this.load()
    }

    async load(){

        if( !this.model ){
            this.data = null
            return this.requestUpdate()
        }

        this.data = await fetch.json(this.model.url()+'/usgs-latest')
        // this.data.date.map(d=>dayjs(d)) 

        this.data.forEach(d=>{

            let latest = d.value[d.value.length-1]

            d.latest = latest
        })

        this.requestUpdate()
    }

    shouldShow(key){
        return true
        return ['Temperature', 'Streamflow', 'Gage height'].includes(key)
    }

    render(){return html`

        <b-table rounded>
            <b-table-row slot="header">
                <b-text w="2fr" xbold md>USGS Sensor</b-text>
                <b-text w="1.5fr">Value</b-text>
                <b-text w="1fr">Date</b-text>
            </b-table-row>


        
        ${this.data?.map(d=>html`
            <b-table-row gap=" " ?hidden=${!this.shouldShow(d.name)} .model=${d} sensor=${d.name}>
                
                <b-text semibold>
                    <b-text .html=${d.name}></b-text>
                </b-text>
                
                <b-text>
                    ${d.name=='Temperature'?html`
                        <b-text tnum>${d.latest?.val}</b-text> <b-text dim>˚F</b-text>
                    `:html`
                        <b-text tnum><b-decimal .num=${d.latest?.val} placeholder="-"></b-decimal></b-text> <b-text dim>${d.unit}</b-text>
                    `}
                </b-text>

                <b-text dim style="min-width: 0" clip>
                    <b-ts .date=${d.latest?.ts}></b-ts>
                </b-text>

                <m-feature-detail-usgs-chart colspan .coll=${d}></m-feature-detail-usgs-chart>

            </b-table-row>
        `)}

        ${!this.data?.length?html`
            <b-empty-state colspan style="min-height: 400px">Loading sensor data...</b-empty-state>
        `:''}

        <b-table-row>
            <b-flex colspan>
                <b-text muted sm>ID: ${this.model.get('iid')}</b-text>
                <b-text sm italic link clear color="theme" href="https://waterdata.usgs.gov/monitoring-location/${this.model.get('iid')}" target="_blank">View on USGS.gov</b-text>
            </b-flex>
        </b-table-row>

        </b-table>

        
    `}

})

export default customElements.get('m-feature-detail-usgs')